import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { CreatePriorityData, SpecilatySelectedValue, PrioritySelectedValue, PriorityList } from 'src/app/models/provider';
import { Table, LazyLoadEvent, SelectItem } from "primeng";
import { CountriesService } from 'src/app/services/countries.service';
import { ProviderStateService } from 'src/app/services/provider-state.service';
import { ApiResult, ErrorModel, PromiseResult, ServerError } from 'src/app/models/PromiseResult';
import { GraphqlService } from 'src/app/services/graphql.service';
import { SpecialityService } from 'src/app/services/speciality.service';
import { Specialty } from 'src/app/models/Speciality';
import { ApolloError } from '@apollo/client/errors';
import { name_input, address, city, phoneNumber, zipCode, textareaBox, dose_input, number_input, URLS } from 'src/app/constant/constant';
import { CountrySelectedValue } from 'src/app/models/doctorregistration';
import { UtilitiesService } from 'src/app/utilities/utilities.service';
import { MessageService } from 'primeng/api';


@Component({
  selector: 'app-priority-list',
  templateUrl: './priority-list.component.html',
  styleUrls: ['./priority-list.component.css', '../../../../../assets/css/custom-egd.css'],
})
export class PriorityListComponent implements OnInit {
  priorities: PriorityList[] = [];
  readonly displayedColumns: string[] = [
    'Id',
    'Transaction Type',
    'Consultation Name',
    'Priority Type',
    'Is Enabled',
    'Amount',
    'Number of Consultations'
  ];

  readonly columnFieldMapping: { [key: string]: string } = {
    'Id': 'id',
    'Transaction Type': 'transaction_type',
    'Consultation Name': 'consultation_name',
    'Priority Type': 'priority_type',
    'Is Enabled': 'is_enabled',
    'Amount': 'renderedAmount',
    'Number of Consultations': 'number_of_consultations'
  };

  posting: boolean = false;
  provider_id: string = "";
  ErrorMessage: string = null;
  response: PromiseResult;
  error: ErrorModel;
  visible: boolean = false;
  createpriority: CreatePriorityData = new CreatePriorityData();
  serverError: ServerError;
  loading: boolean = false;
  is_uk_country: boolean = false;
  readonly name_input: RegExp = name_input;
  readonly address: RegExp = address;
  readonly city_input: RegExp = city;
  readonly phoneNumber: RegExp = phoneNumber;
  readonly zipCode: RegExp = zipCode;
  readonly textarea: RegExp = textareaBox;
  readonly dose_input: RegExp = dose_input;
  readonly number_input: RegExp = number_input;
  status_list: SelectItem[] = [
    { label: 'Yes', value: true },
    { label: 'No', value: false }
  ];


  constructor(
    private readonly countryService: CountriesService,
    private readonly providerstateService: ProviderStateService,
    private readonly graphqlService: GraphqlService,
    private readonly specialtyService: SpecialityService,
    private readonly utilitiesService: UtilitiesService,
    private messageService: MessageService,
    private readonly cdr: ChangeDetectorRef
  ) { }

  async ngOnInit() {
    this.provider_id = this.providerstateService.getProviderId();
    if(URLS.IS_UK)
    {
      this.is_uk_country = true;
    }
    await this.getCountries();
    await this.GetSpecialties(this.provider_id);
    await this.getConsultationsAndStatusList();
    // this.InitFilter(false);
    this.GetPriorityList();
  }



  async getConsultationsAndStatusList() {
    this.createpriority.other_data.consultations = [
      // {
      //   label: 'Expert Second Medical Opinion',
      //   value: 1
      // },
      {
        label: 'Primary Medical Consultation',
        value: 2
      },
      {
        label: 'Follow Up Consultation',
        value: 3
      },
      {
        label: 'Multi Specialty Consultation',
        value: 4
      }
    ];
    if (!this.is_uk_country) {
      this.createpriority.other_data.consultations.push({
        label: 'Expert Second Medical Opinion',
        value: 1
      });
    }
    else if (this.is_uk_country) {
      this.createpriority.other_data.consultations.push({
        label: 'Specialist Consultation',
        value: 1
      });
    }

    // this.createpriority.other_data.consultations.forEach((ele) => {
    //   ele["final_value"] = JSON.stringify({
    //     value: Number(ele.value),
    //   } as PrioritySelectedValue);
    // });

    this.createpriority.other_data.consultations.forEach((ele, index) => {
      let data: PrioritySelectedValue = {
        label: ele.label,
        value: ele.value,
      };
      ele['final_value'] = data;
    });
    this.createpriority.other_data.consultations =
      this.utilitiesService.getSelectItemList(
        this.createpriority.other_data.consultations,
        'label',
        'final_value'
      );

    // this.createpriority.other_data.consultations = this.utilitiesService.getSelectItemList(this.createpriority.other_data.consultations, "label", "final_value");



    // this.status_list.forEach((ele) => {
    //   ele["final_value"] = JSON.stringify({
    //     value: Number(ele.value),
    //   } as PrioritySelectedValue);
    // });
    // this.status_list = this.utilitiesService.getSelectItemList(this.status_list, "label", "final_value");


    this.status_list.forEach((ele, index) => {
      let data: PrioritySelectedValue = {
        label: ele.label,
        value: ele.value,
      };
      ele['final_value'] = data;
    });
    this.status_list = this.utilitiesService.getSelectItemList(this.status_list, 'label', 'final_value');

  }


  async getCountries(): Promise<void> {
    await this.countryService
      .getCountries(this.provider_id)
      .toPromise()
      .then((countries) => {
        countries.forEach((ele, index) => {
          let data: CountrySelectedValue = {
            id: Number(ele.id),
            is_national_license: ele.is_national_license,
            phone_code: '+' + String(ele.phone_code),
          };
          ele['final_value'] = data;
        });
        this.createpriority.other_data.countries =
          this.utilitiesService.getSelectItemList(
            countries,
            'country_name',
            'final_value'
          );
      })
      .catch((err) => {
        console.error(err);
      });
    // await this.reset_defaults();
  }

  async GetSpecialties(provider_id: string) {
    await this.specialtyService
      .GetAllSupported(undefined, provider_id)
      .toPromise()
      .then((result) => {
        this.createpriority.other_data.specialties = [];
        let specialties: Specialty[] = result.data;
        specialties.forEach((ele, index) => {
          let data: SpecilatySelectedValue = {
            id: Number(ele.id),
            specialty_name: ele.specialty_name
          };
          ele['final_value'] = data;
        });
        this.createpriority.other_data.specialties =
          this.utilitiesService.getSelectItemList(
            specialties,
            'specialty_name',
            'final_value'
          );
      })
      .catch((err) => {
        console.error(err);
      });
    // await this.reset_defaults();
  }



  // async InitFilter(call_api: boolean) {
  //   this.query = {
  //     country_id: null,
  //     consultation_type_id: { _eq: 0 },
  //     is_enabled: null
  //   };
  //   if (call_api) {
  //     await this.GetPriorityList(null);
  //   }
  // }

  GetPriorityList() {
    this.posting = true;
    this.loading = true;
    this.graphqlService.findPriorityTypes().subscribe((result) => {
      if (result) {
        this.priorities = result;
        this.priorities = this.priorities.map(priority => ({
          ...priority,
          id: Number(priority.id)
        }));

        this.priorities = [...this.priorities]
      }
      this.posting = false;
      this.loading = false;
    }, console.error);
  }


  Cancel() {
    this.visible = false;
  }
  openDialog() {
    this.visible = true;
  }


  private ResetResponseModel(): void {
    this.response = { success: null, error: null, data: null };
    this.serverError = { statusCode: null, error: null, message: null };
  }

  private handleError(error: any): void {
    this.ErrorMessage = 'Failed to fetch data';
    console.error('An error occurred:', error);
    this.posting = false;
  }



  async createPriority() {
    const selectedDoctorOriginData = Array.isArray(this.createpriority.other_data.selected_doctor_origin_data)
      ? this.createpriority.other_data.selected_doctor_origin_data
      : [this.createpriority.other_data.selected_doctor_origin_data];

    const doctorOriginCountryIds = selectedDoctorOriginData.map((country: CountrySelectedValue) => country.id);


    this.createpriority.api_data.create_api_result = new ApiResult(true);
    this.createpriority.api_data.priority.country_id = this.createpriority.other_data.selected_country_data.id;
    this.createpriority.api_data.priority.currency_country_id = this.createpriority.other_data.selected_country_data.id;
    this.createpriority.api_data.priority.specialty_id = this.createpriority.other_data.selected_specialty_data.id;
    this.createpriority.api_data.priority.consultation_type_id = Number(this.createpriority.other_data.selected_consultation_type_data.value);
    this.createpriority.api_data.priority.doctor_origin_country_ids = doctorOriginCountryIds;
    this.createpriority.api_data.priority.is_enabled = Boolean(this.createpriority.other_data.selected_is_enabled_data.value);
    const input = {
      specialty_id: this.createpriority.api_data.priority.specialty_id,
      is_enabled: this.createpriority.api_data.priority.is_enabled,
      currency_country_id: this.createpriority.api_data.priority.country_id,
      amount: Number(this.createpriority.api_data.priority.amount),
      country_id: this.createpriority.api_data.priority.country_id,
      // currency_country_id: this.createpriority.api_data.priority.currency_country_id,
      consultation_type_id: this.createpriority.api_data.priority.consultation_type_id,
      doctor_origin_country_ids: this.createpriority.api_data.priority.doctor_origin_country_ids
    };

    this.graphqlService.createPriorityType(input).subscribe(
      (result) => {
        this.createpriority.api_data.create_api_result.Posting = false;
        this.createpriority.resetData();
        this.visible = false;
        location.reload();
      },
      (error: ApolloError) => {
        if (error.graphQLErrors) {
          for (const graphQLError of error.graphQLErrors) {
            // Handle specific GraphQL error codes
            if (graphQLError.extensions.code === 'BAD_REQUEST') {
              const messages: string[] = graphQLError.extensions.originalError.message
              this.createpriority.api_data.create_api_result.ServerError.error = messages.join(",")
              this.createpriority.api_data.create_api_result.ServerError.message = messages
              this.createpriority.api_data.create_api_result.ServerError.statusCode = 400
            }
            else if (graphQLError.extensions.code === 'INTERNAL_SERVER_ERROR') {
              const messages: string[] = [graphQLError.message]
              this.createpriority.api_data.create_api_result.ServerError.error = messages.join(",")
              this.createpriority.api_data.create_api_result.ServerError.message = messages
              this.createpriority.api_data.create_api_result.ServerError.statusCode = 400
            }
            else {
              const messages: string[] = ['Something went wrong!!']
              this.createpriority.api_data.create_api_result.ServerError.error = null
              this.createpriority.api_data.create_api_result.ServerError.message = messages
              this.createpriority.api_data.create_api_result.ServerError.statusCode = 500
            }
          }
        } else if (error.networkError) {
          const messages: string[] = ['Network Error']
          this.createpriority.api_data.create_api_result.ServerError.error = messages.join(",")
          this.createpriority.api_data.create_api_result.ServerError.message = messages
          this.createpriority.api_data.create_api_result.ServerError.statusCode = 500
        }

        this.createpriority.api_data.create_api_result.PromiseResult.success = false;
        this.createpriority.api_data.create_api_result.Posting = false;
      }
    );
  }
  UpdatePriority(id: number, is_enabled: boolean) {


    const input = {
      id: Number(id),
      is_enabled: is_enabled
    };

    this.graphqlService.updatePriorityType(input).subscribe(
      (result) => {
        if (result && result.data) {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Priority status updated successfully',
          });
          location.reload();
        }
      },
      (error: ApolloError) => {
        console.error('GraphQL error:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to update priority status',
        });
      }
    );
  }



}
